export function tabOrder() {
    //Tab order fixes
    if (window.innerWidth > 1200) {
        $('.footer-contact').insertAfter('.menu-quicklinks');
    }
}
